 
  <div *ngIf="!loading; else loader" style="max-width:320px">
         <nb-card >
    
      <nb-card-body>
    <div style="padding:10px 15px 15px 15px ;">
        	

         
      <p class="head"> Підключення тарифу {{currentTariff.label}} </p>
	<div class="description">{{currentTariff.shortDescription}} у трансляціях і завантажених відео.</div>
	<div class="description" *ngIf="currentTariff.storageQuotaGb">{{currentTariff.storageQuotaGb}} ГБ місця для записів і відео</div>
      

				<div class="price">
					<div>
						<!--<div class="pricePerMonth"> <div class="txt">{{pricePerMonth}}</div> <div class="cur">грн</div> </div>-->
						 
						<div class="pricePerMonthCurrent"><div class="txt">{{pricePerMonthCurrent}}</div> <div class="cur">грн</div> </div>

						<div class="lbl">в місяць</div>
					</div>
				</div>
 

  
				<!--<div class="total">К оплате: {{totalPrice}} грн</div>-->

 			

			      <div class="buttonWrapper">
					<div><button   (click)="submit()" nbButton status="primary">підключити</button></div>
				</div>

	   	<div class="description-bottom">списується з балансу в сервісі</div>
  
    </div>
  </nb-card-body> 
    </nb-card>
     
  </div>
 



   <ng-template #loader>
        <div style="position: fixed; z-index: 1001; background:rgba(0,0,0,0.7); width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
        <div style="margin: auto;"> 
             <app-loader></app-loader>
         </div>
        </div>
    </ng-template> 

	 



